import { Check, Loader2, X } from 'lucide-react';
import React from 'react';
function ValidationStatus({
  isValidating = false,
  isValid = false,
  hasError = false
}) {
  if (!isValidating && !isValid && !hasError) {
    return null;
  }
  return <div className="absolute right-3 top-1/2 " data-sentry-component="ValidationStatus" data-sentry-source-file="validation-status.tsx">
      {isValidating && <Loader2 className="size-6 animate-spin text-blue-500" />}

      {!isValidating && isValid && <div className="rounded-full bg-green-500 p-1">
          <Check className="size-4 text-white" />
        </div>}

      {!isValidating && !isValid && hasError && <div className="rounded-full bg-red-500 p-1">
          <X className="size-4 text-white" strokeWidth={4} />
        </div>}
    </div>;
}
export default ValidationStatus;